import { useState } from 'react';

interface LogoMarkProps {
  name: string;
  logoUrl?: string | null;
  size?: number;
  className?: string;
}

export default function LogoMark({ name, logoUrl, size = 32, className = '' }: LogoMarkProps) {
  const [broken, setBroken] = useState(false);
  const showImage = !!logoUrl && !broken;
  const initial = (name?.[0] ?? '?').toUpperCase();
  const padding = Math.max(2, Math.round(size / 8));

  return (
    <div
      className={`flex items-center justify-center shrink-0 rounded-sm border border-border bg-surface overflow-hidden ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {showImage ? (
        <img
          src={logoUrl!}
          alt=""
          className="w-full h-full object-contain"
          style={{ padding }}
          onError={() => setBroken(true)}
        />
      ) : (
        <span
          className="font-mono uppercase text-accent"
          style={{
            fontSize: Math.round(size * 0.5),
            lineHeight: 1,
            borderColor: 'var(--accent)',
          }}
        >
          {initial}
        </span>
      )}
    </div>
  );
}
